var _rect, _path, _rect2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPyeongSize = function SvgPyeongSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 1,
    x: 2.001,
    y: 21,
    fill: "currentColor",
    rx: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.563 23.293a.24.24 0 0 1-.41-.17V19.98a.24.24 0 0 1 .41-.17l1.572 1.572a.24.24 0 0 1 0 .34z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 1,
    x: 2,
    y: 22,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-90 2 22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.193 2.742a.24.24 0 0 1-.17.41H.88a.24.24 0 0 1-.17-.41L2.281 1.17a.24.24 0 0 1 .34 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M18.72 16.8H7.2a.24.24 0 0 1-.24-.24V9.715a.24.24 0 0 1 .091-.187l5.76-4.608a.24.24 0 0 1 .3 0l5.76 4.608a.24.24 0 0 1 .09.187v6.845a.24.24 0 0 1-.24.24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M13.92 12H12a.24.24 0 0 1-.24-.24V9.84A.24.24 0 0 1 12 9.6h1.92a.24.24 0 0 1 .24.24v1.92a.24.24 0 0 1-.24.24Z"
  })));
};
export default SvgPyeongSize;